import { createFileRoute } from "@tanstack/react-router";
import { DisruptDoctorDirectories } from "@/components/press/articles/DisruptDoctorDirectories";

const SITE = "https://heallexa.com";
const URL = `${SITE}/press/disrupt-doctor-directories`;
const TITLE =
  "New AI Health Discovery Platform Heallexa Goes Live, Disrupting Traditional Doctor Directories";
const DESCRIPTION =
  "Heallexa launches a zero-fee healthcare discovery network with WhatsApp AI, SMS routing, and autonomous voice receptionists, instantly matching patients with local providers.";
const DATE_ISO = "2026-06-08";

export const Route = createFileRoute("/press/disrupt-doctor-directories")({
  head: () => ({
    meta: [
      { title: `${TITLE} | Heallexa` },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "article" },
      { property: "article:published_time", content: DATE_ISO },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NewsArticle",
          headline: TITLE,
          description: DESCRIPTION,
          datePublished: DATE_ISO,
          dateModified: DATE_ISO,
          url: URL,
          author: { "@type": "Organization", name: "Heallexa", url: SITE },
          publisher: {
            "@type": "Organization",
            name: "Heallexa",
            logo: { "@type": "ImageObject", url: `${SITE}/logo.png` },
          },
          mainEntityOfPage: { "@type": "WebPage", "@id": URL },
        }),
      },
    ],
  }),
  component: DisruptDoctorDirectories,
});
